import NextImage from "@/components/NextImage";
import { validateImgSrc } from "@/utils/global";
import Link from "next/link";
// import React, { useState } from "react";

const BannerItem = ({ src, href, alt, aspectRatio, width, height }) => {
  // const [loaded, setLoaded] = useState(false);

  return (
    <Link
      href={href || "/#"}
      className={`w-full aspect-[${aspectRatio}] overflow-hidden relative rounded-xl`}
    >
      {/* Skeleton Placeholder */}
      {/* {!loaded && <div className="absolute inset-0 " />} */}

      <NextImage
        priority
        src={validateImgSrc(src)}
        width={width}
        height={height}
        alt={alt}
        className={`object-fill w-full h-auto transition-transform duration-500 hover:scale-[1.01] relative `}
      />
    </Link>
  );
};

const Banners = ({ banners, img: catImage, name }) => {
  // const [loaded, setLoaded] = useState(false);

  if (banners?.length > 0) {
    const grid = `grid grid-cols-1 md:grid-cols-${banners?.length} gap-4`;
    const aspectRatio = `${banners?.length}/1`;
    const width = 1600 / banners?.length;
    const height = 210;

    return (
      <div className={`w-full my-5 mx-auto ${grid}`}>
        {banners?.map((bnr, idx) => (
          <BannerItem
            key={idx}
            href={bnr.url}
            src={bnr.image_src}
            alt={name}
            aspectRatio={aspectRatio}
            width={width}
            height={height}
          />
        ))}
      </div>
    );
  }

  if (catImage) {
    return (
      <div className="relative w-full overflow-hidden aspect-[1440/350]">
        {/* this loader is causing CLS in the first load  if we don`t put a skeleton with the useClient hook  */}
        {/* {loaded && <div className="absolute inset-0 " />} */}

        <NextImage
          priority
          src={validateImgSrc(catImage)}
          width={1440}
          height={350}
          quality={100}
          // onLoad={() => setLoaded(true)}
          className={`object-contain w-full h-full relative`}
        />
      </div>
    );
  }

  return null;
};

export default Banners;
